import { Button, Typography } from "antd";
import React, { useEffect } from "react";
import { formatString } from "../Common/ColorCode";
import moment from "moment";
import { ArrowLeftOutlined, SearchOutlined } from "@ant-design/icons";
import ClinicMap from "./ClinicMap";
import { filterByNonGpProductId } from "../Common/CommonFunction";
import { pushTraceLogEvent } from "./sessionEventPush";

const { Title } = Typography;
function formatPrice(value) {
  return Number(value).toLocaleString('en-IN', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
}

let tempData = {
  product: "General GP consultation",
  data: [
    {
      key: "Duration",
      data: "15 minutes",
    },
    {
      key: "Language",
      data: "Arabic",
    },
    {
      key: "Gender",
      data: "Male",
    },
  ],
  date: "14 January, 2025",
  time: "10:30",
  name: "Oxford Street",
  address: "6 Newburgh Street, Carnaby, London, W1F 7RQ",
};

const BookingDetailsNext = (props) => {
  // console.log('::::::BookingDetailsNext:::::', props)
  let tempDataForDuration = [];
  // useEffect(() => {
  // console.log('::::::useEffect:::::', props.showAppoinmentData.duration)
  if (props.showAppoinmentData && props.showAppoinmentData.duration) {
    tempDataForDuration.push({
      key: "Duration",
      data:
        props.data &&
          props.data.durationObjectById &&
          props.showAppoinmentData.duration &&
          props.data.durationObjectById[props.showAppoinmentData.duration]
          ? props.data.durationObjectById[props.showAppoinmentData.duration]
            .duration + " minutes"
          : "15 minutes",
    });
  }
  // Price chip — shown after Duration with a label
  {
    const _bdnSlotInfo = props.showAppoinmentData?.slot?.info;
    const _bdnHasAdditional = !!_bdnSlotInfo?.additional_charges;
    const _bdnSlotPrice = _bdnSlotInfo?.price;
    const _bdnDisplayPrice = props.showAppoinmentData?.isUpdate && props.showAppoinmentData?.data?.charges
      ? Math.max(parseFloat(props.showAppoinmentData.data.charges) || 0, parseFloat(_bdnSlotPrice) || 0)
      : _bdnSlotPrice;
    if (!_bdnHasAdditional && _bdnDisplayPrice) {
      tempDataForDuration.push({
        key: "Price",
        data: `£${formatPrice(_bdnDisplayPrice)}`,
      });
    }
  }
  if (props.showAppoinmentData && props.showAppoinmentData.language) {
    let data = "";
    if (
      props.showAppoinmentData.language &&
      props.showAppoinmentData.language.value
    ) {
      data = String(props.showAppoinmentData.language.value);
    } else {
      data = String(props.showAppoinmentData.language);
    }
    let languageName = props.data.languageData.find(
      (landata) => String(landata.value) === data,
    );
    const _bdnLangLabel = languageName ? languageName.label : data;
    // English is the default — no need to display it in the summary
    if (_bdnLangLabel && String(_bdnLangLabel).toLowerCase() !== 'english') {
      tempDataForDuration.push({
        key: "Language",
        data: _bdnLangLabel,
      });
    }
  }
  // Gender: prefer the updated value set by callbackRescheduleBookingForm (showAppoinmentData.gender),
  // then fall back to the original appointment's preferred_gender.
  const isReshedula = props.showAppoinmentData?.clinic?.isReshedula ||
    (props.showAppoinmentData?.isUpdate && props.showAppoinmentData?.data);
  const effectiveGender = isReshedula
    ? (props.showAppoinmentData?.gender ?? props.showAppoinmentData?.data?.preferred_gender)
    : props.showAppoinmentData?.gender;
  if (effectiveGender && effectiveGender !== 'no_preference') {
    tempDataForDuration.push({
      key: "Gender",
      data: formatString(effectiveGender),
    });
  }
  // Price is shown inline in the product name line — do NOT push it to tempDataForDuration
  // }, [props])
  // console.log('showAppoinmentData', props.showAppoinmentData.type)
  return (
    <div>
      <div style={{ display: "grid", justifyContent: "center" }}>
        <div
          style={{
            width: "440px",
            background: "#F0FAFA",
            padding: 10,
            marginTop: 40,
            border: "1px solid #008385",
            borderBottom: "0",
          }}
        >
          {/* Category name */}
          <span style={{ margin: 0, fontSize: 14, color: "#008385", display: 'block' }}>
            {props?.showAppoinmentData?.clinic?.productCategory?.name || ""}
          </span>

          {/* Product name + price — one clean line */}
          {(() => {
            const cat = props?.showAppoinmentData?.clinic?.productCategory;
            const catId = cat?.product_category_id;
            let productName = '';

            if (catId == 2 && props.getAllHealthScreenData?.getAllHealthScreenData?.data) {
              const matched = filterByNonGpProductId(
                props.getAllHealthScreenData.getAllHealthScreenData.data,
                props?.showAppoinmentData?.clinic?.non_gp_product_id
              );
              productName = matched?.[0]?.name || '';
            } else if (catId == 3) {
              const matched = filterByNonGpProductId(
                props?.showAppoinmentData?.clinic?.selectedCorporate?.corporate_products,
                props?.showAppoinmentData?.clinic?.non_gp_product_id
              );
              productName = matched?.[0]?.name || '';
            } else if (cat?.type === 'd2c' || (catId && catId != 1)) {
              productName = props?.showAppoinmentData?.clinic?.productData?.name
                || props?.showAppoinmentData?.selectedProduct?.name
                || '';
            }

            if (!productName) return null;

            return (
              <span style={{ margin: 0, fontSize: 14, color: "#008385", display: 'block' }}>
                {productName}
              </span>
            );
          })()}

          {/* Duration / Language / Gender — each on its own row */}
          {(() => {
            const catType = props?.showAppoinmentData?.clinic?.productCategory?.type;
            const visibleChips = tempDataForDuration.filter((rs) => {
              // GP: hide English (no-preference default); non-GP: user confirmed it
              if (rs.key === "Gender" && rs.data.toLowerCase() === "no preference") return false;
              return true;
            });
            if (!visibleChips.length) return null;
            return (
              <div style={{ fontSize: 13, display: 'flex', justifyContent: 'center', flexWrap: 'wrap', gap: '0 4px' }}>
                {visibleChips.map((rs, i) => (
                  <React.Fragment key={rs.key ?? i}>
                    <span style={{ color: '#000' }}>{rs.key}:&nbsp;<span style={{ color: '#008385', fontWeight: 500 }}>{rs.data}</span></span>
                    {i !== visibleChips.length - 1 && <span style={{ color: '#000', margin: '0 6px' }}>|</span>}
                  </React.Fragment>
                ))}
              </div>
            );
          })()}
        </div>
        <div
          style={{
            width: "440px",
            background: "#F0FAFA",
            padding: "15px",
            border: "1px solid #008385",
          }}
        >
          <span style={{ margin: 0, fontSize: 20, color: "#000" }}>
            {props?.showAppoinmentData &&
              props?.showAppoinmentData.slot &&
              props.showAppoinmentData.slot?.date
              ? moment(props.showAppoinmentData.slot.date).format(
                "D MMMM, YYYY",
              )
              : ""}
            {" "}|{" "}
            {props?.showAppoinmentData &&
              props?.showAppoinmentData.slot &&
              props.showAppoinmentData.slot.info &&
              props.showAppoinmentData.slot.info.start_time
              ? props.showAppoinmentData.slot.info.start_time
              : ""}
            {/* | {props?.showAppoinmentData && props?.showAppoinmentData.slot && props.showAppoinmentData.slot.info && props.showAppoinmentData.slot.info.price ? props.showAppoinmentData.slot.info.price : ''} */}
          </span>
        </div>
        <div
          style={{
            width: "440px",
            display: "flex",
            justifyContent: "flex-start",
            marginTop: 20,
          }}
        >
          <div
            style={{
              width: 90,
              height: 90,
              borderRadius: "10px",
              marginLeft: 1,
            }}
          >
            {/* <iframe
                            width={76}
                            height={76}
                            style={{ border: "0", marginTop: 0 }}
                            loading="lazy"
                            // allowFullScreen
                            src={`https://www.openstreetmap.org/export/embed.html?bbox=${props.showAppoinmentData?.slot?.clinicData?.longitude},${props.showAppoinmentData?.slot?.clinicData?.latitude},${props.showAppoinmentData?.slot?.clinicData?.longitude},${props.showAppoinmentData?.slot?.clinicData?.latitude}&layer=mapnik`}
                        ></iframe> */}
            <ClinicMap
              widthAndheight={{ width: 76, height: 76 }}
              passData={{
                cood: [
                  {
                    id: props.showAppoinmentData?.slot?.clinicData?.id,
                    name: props.showAppoinmentData?.slot?.clinicData?.name,
                    data: [
                      props.showAppoinmentData?.slot?.clinicData?.latitude,
                      props.showAppoinmentData?.slot?.clinicData?.longitude,
                    ],
                  },
                ],
              }}
            />
          </div>
          <div style={{ textAlign: "left", marginLeft: 30 }}>
            <p style={{ fontSize: 14 }}>
              {props.showAppoinmentData?.slot?.clinicData?.name
                ? props.showAppoinmentData.slot.clinicData.name
                : ""}
            </p>
            <p style={{ fontSize: 14 }}>
              {props.showAppoinmentData?.slot?.clinicData?.address
                ? props.showAppoinmentData?.slot?.clinicData?.address
                : ""}
            </p>
          </div>
        </div>
      </div>
      {!props?.hide && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: 5,
            paddingBottom: "20px",
            alignItems: "center",
          }}
        >
          <Button
            shape="circle"
            icon={
              <ArrowLeftOutlined
                style={{ color: "#008385", fontSize: "18px" }}
              />
            }
            style={{
              backgroundColor: "#C8E6E6", // Light teal
              border: "none",
              width: "40px",
              height: "40px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginTop: 0,
              marginRight: 10,
              boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
            }}
            onClick={() => {
              if (props.stopCountdown) {
                props.stopCountdown();
              }
              props.callBackForbackpage(
                props.showAppoinmentData.type
                  ? props.showAppoinmentData.type
                  : "BookingForm",
              );
              pushTraceLogEvent({
                event: "navigate_to_clinc_selection_page",
                payload: {
                  action: "navigate to clinic selection page",
                },
                step_status: "success",
              });
            }}
          />
          {props?.CountdownDisplay && <props.CountdownDisplay />}
          <Button
            onClick={() => {
              props.callback({ nexData: "data" }, "BookingDetailsNext");
              pushTraceLogEvent({
                event: "booking_details_next_clicked",
                payload: {
                  appointmentType:
                    props.showAppoinmentData?.clinic?.productCategory?.title,
                  //   appointmentDate: formattedDateForIPHONE,
                  appointmentTime:
                    props?.showAppoinmentData?.slot?.info?.start_time || "",
                  date: new Date().toISOString().split("T")[0],
                },
                step_status: "success",
              });
            }}
            type="primary"
            style={{
              background: "#008385",
              borderColor: "#008385",
              width: 182,
              height: 40,
              marginLeft: 10,
            }}
          >
            Continue
          </Button>
        </div>
      )}
    </div>
  );
};

export default BookingDetailsNext;
